import { render, staticRenderFns } from "./CarryForward.vue?vue&type=template&id=59c98e6a&scoped=true"
import script from "./CarryForward.vue?vue&type=script&lang=js"
export * from "./CarryForward.vue?vue&type=script&lang=js"
import style0 from "./CarryForward.vue?vue&type=style&index=0&id=59c98e6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c98e6a",
  null
  
)

export default component.exports